export const MS_PER_MINUTE = 60 * 1000;
export const MS_PER_HOUR = MS_PER_MINUTE * 60;
export const MS_PER_DAY = MS_PER_HOUR * 24;
export const MS_PER_MONTH = MS_PER_DAY * 30;
export const MS_PER_YEAR = MS_PER_DAY * 365;

/**
 * Returns a human-readable "saved X ago" string based on elapsed milliseconds.
 * When `savedAtMs` is null, returns the "moments ago" fallback.
 */
export function getRelativeTimeString(current: number, savedAtMs: number | null): string {
  if (savedAtMs === null) {
    return window.i18next.t('pmwjs_saved_moments_ago');
  }
  const elapsed = current - savedAtMs;

  if (elapsed < MS_PER_MINUTE) {
    return window.i18next.t('pmwjs_saved_moments_ago');
  }
  if (elapsed < MS_PER_HOUR) {
    const val = Math.round(elapsed / MS_PER_MINUTE);
    return val === 1 ? window.i18next.t('pmwjs_saved_a_minute_ago') : window.i18next.t('pmwjs_saved_x_minutes_ago', {minutes: val});
  }
  if (elapsed < MS_PER_DAY) {
    const val = Math.round(elapsed / MS_PER_HOUR);
    return val === 1 ? window.i18next.t('pmwjs_saved_an_hour_ago') : window.i18next.t('pmwjs_saved_x_hours_ago', {hours: val});
  }
  if (elapsed < MS_PER_MONTH) {
    const val = Math.round(elapsed / MS_PER_DAY);
    return val === 1 ? window.i18next.t('pmwjs_saved_a_day_ago') : window.i18next.t('pmwjs_saved_x_days_ago', {days: val});
  }
  if (elapsed < MS_PER_YEAR) {
    const val = Math.round(elapsed / MS_PER_MONTH);
    return val === 1 ? window.i18next.t('pmwjs_saved_a_month_ago') : window.i18next.t('pmwjs_saved_x_months_ago', {months: val});
  }
  const val = Math.round(elapsed / MS_PER_YEAR);
  return val === 1 ? window.i18next.t('pmwjs_saved_a_year_ago') : window.i18next.t('pmwjs_saved_x_years_ago', {years: val});
}
